import { faqAccount } from './faq-account';
import { faqBilling } from './faq-billing';
import { faqGeneral } from './faq-general';
import { faqLearning } from './faq-learning';
import { faqTroubleshooting } from './faq-troubleshooting';
import type { IFaqCategory } from './faq-types';
import { faqWatch } from './faq-watch';

export const faqCategories: IFaqCategory[] = [
  faqGeneral,
  faqLearning,
  faqBilling,
  faqAccount,
  faqWatch,
  faqTroubleshooting,
];
